import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";

class BookingService {

  /* ---------------- BOOK TRAVEL PACKAGE ---------------- */
  static travelPackageBook(payload) {
    const api = API_PATHS.booktravelpackage;

    return axiosInstance.post(api, payload);
  }

   static waterSportsBook(payload) {
    const api = API_PATHS.bookwatersports;

    return axiosInstance.post(api, payload);
  }

  /* ---------------- VERIFY PAYMENT ---------------- */
  static verifyPayment(payload) {
    const api = API_PATHS.verifyPayment;

    return axiosInstance.post(api, payload);
  }

  static getBooking() {
  const api = API_PATHS.getBooking;

  return axiosInstance.get(api);
}


}

export default BookingService;
